import React, { Component } from 'react';
import 'HELPDESK/Components/QueryDetails/ViewRequestModal/viewrequestmodal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bookIcon from "HELPDESK/CommonResources/images/bookIcon.png";
import AssignedDateImage from "HELPDESK/CommonResources/images/AssignedDateImage.png";
import StatusImage from "HELPDESK/CommonResources/images/statusImage.png";
import ClientCommunication from 'HELPDESK/Components/QueryDetails/ViewRequestModal/ClientCommunication/ClientCommunication';
import ClientResponse from 'HELPDESK/Components/QueryDetails/ViewRequestModal/ClientResponse/ClientReponse';
import backToRequests from "HELPDESK/CommonResources/images/rightArrowIcon.png";
import VerticalStepper from 'HELPDESK/Components/QueryDetails/ViewRequestModal/VerticalStepper/VerticalStepper';
import HelpdeskApiCall from 'HelpdeskApiCall';

import { toast } from 'react-toastify';
import ExecutiveResponse from 'HELPDESK/Components/QueryDetails/ViewRequestModal/ExecutiveResponse/ExecutiveResponse';
import EnhancementVerticalStepper from 'HELPDESK/Components/QueryDetails/ViewRequestModal/EnhancementVerticalStepper/EnhancementVerticalStepper';
import EnhancementClientCommunication from 'HELPDESK/Components/QueryDetails/ViewRequestModal/EnhancementClientCommunication/EnhancementClientCommunication';
import QuotationApproval from './QuotationApproval/QuotationApproval';
import AddRequestModal from 'HELPDESK/Components/QueryDetails/AddRequestModal/AddRequestModal';
import config from 'config';

export class ViewRequestModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openServiceRequestModal: this.props.openServiceRequestModal,
      selectedResponse: 'Client Response',
      selectedCommunicationTeam: 'Client Communication',
      currentQueryRequestId: this.props.srId,
      currentClientResponse: {},
      clientResponseFetching: false,
      currentReleaseDetails: {},
      currentQueryStatus: "",
      messageToShow: "",
      queryType: "",
      reOpenSrModal: false,
      currentQueryStatusLabel: "",
      loading: false,
      isEstimationAvailble: false,
    }
  }
  componentDidMount() {
    // this.apiCallToGetQueryList();
    this.apiCallToGetClientResponse();
    if (this.props.userQueryType === 'enhancements') {

      this.apiCallToGetEstimationCostList();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.openServiceRequestModal && !prevProps.openServiceRequestModal) {
      this.setState({ reOpenSrModal: false });
    }
  }


  apiCallToGetEstimationCostList = async () => {
    this.setState({ loading: true });

    let requestData = {
      "iid": config.institute_id,
      "serviceRequestId": this.state.currentQueryRequestId,
      "addedBy": config.userId
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_getSrWiseCostEstimation',
      requestData,
      '/api/projectManagement/Queries/pmTool_userServiceRequestReceivedData.php'
    );

    if (jsonResponse.success) {
      if (jsonResponse.APIResult.status === 'fail') {
        const isEstimationAvailble = jsonResponse.APIResult?.isEstimation === 'yes';

        let updatedState = {
          loading: false,
          isEstimationAvailble: isEstimationAvailble
        };

        if (
          this.state.currentClientResponse &&
          Object.keys(this.state.currentClientResponse).length > 0
        ) {
          const allowedStatuses = [
            'Admin Document Approval',
            'Quotation Approval by Client',
            'Release Planning',
            'UX Completed',
            'QA Approved Available on Production',
            'Closer confirmation',
            'Close'
          ];
          
          const currentStatus = Object.values(this.state.currentClientResponse)[0]?.currentStatus;
          const isStatusAllowed = allowedStatuses.includes(currentStatus);
          const isCCAdmin = this.props.isCCAdminMember === "true";

          const canShowForEveryone = isStatusAllowed && this.props.userQueryType === 'enhancements' && isEstimationAvailble;
          const canShowForAdmin = isStatusAllowed && isEstimationAvailble && isCCAdmin;

          updatedState.selectedCommunicationTeam =
            (canShowForEveryone || canShowForAdmin)
              ? "Quotation Approval"
              : "Client Communication";
        } else {
          updatedState.isEstimationAvailble = false;
        }

        this.setState(updatedState);

      } else {

        const isEstimationAvailble = jsonResponse.APIResult?.isEstimation === 'yes';

        let updatedState = {
          loading: false,
          isEstimationAvailble: isEstimationAvailble
        };

        if (
          this.state.currentClientResponse &&
          Object.keys(this.state.currentClientResponse).length > 0
        ) {
          const allowedStatuses = [
            'Admin Document Approval',
            'Quotation Approval by Client',
            'Release Planning',
            'UX Completed',
            'QA Approved Available on Production',
            'Closer confirmation',
            'Close'
          ];
          
          const currentStatus = Object.values(this.state.currentClientResponse)[0]?.currentStatus;
          const isStatusAllowed = allowedStatuses.includes(currentStatus);
          const isCCAdmin = this.props.isCCAdminMember === "true";

          const canShowForEveryone = isStatusAllowed && this.props.userQueryType === 'enhancements' && isEstimationAvailble;
          const canShowForAdmin = isStatusAllowed && isEstimationAvailble && isCCAdmin;

          updatedState.selectedCommunicationTeam =
            (canShowForEveryone || canShowForAdmin)
              ? "Quotation Approval"
              : "Client Communication";
        } else {
          updatedState.isEstimationAvailble = false;
        }

        this.setState(updatedState);

      }

       this.setState({ isEstimationAvailble: jsonResponse.APIResult?.isEstimation === 'yes', loading: false, });
      // debugger;
    } else {
      this.setState({ isEstimationAvailble: false, loading: false, });
    }
  };

  apiCallToGetClientResponse = async () => {
    this.setState({
      clientResponseFetching: true,
    })
    const requestData = {
      serviceRequestId: this.state.currentQueryRequestId,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'helpDesk_getClientServiceRequestDetails',
      requestData,
      '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetClientResponse();
      }, 1000);
    } else {


      if (jsonResponse.success) {
        // if (jsonResponse.APIResult.status === 'success') {
        let apiResult = jsonResponse.APIResult.data;




        // Update state with API data
        const allowedStatuses = [
          'Admin Document Approval',
          'Quotation Approval by Client',
          'Release Planning',
          'UX Completed',
          'QA Approved Available on Production',
          'Closer confirmation',
          'Close'
        ];
        
        const isCCAdmin = this.props.isCCAdminMember === "true";
        
        this.setState({
          currentClientResponse: apiResult, clientResponseFetching: false,
          currentReleaseDetails: Object.keys(apiResult).length > 0 ? Object.values(apiResult)[0].releaseData : {},
          currentQueryStatus: Object.keys(apiResult).length > 0 ? Object.values(apiResult)[0]?.currentStatusLabel : "",
          currentQueryStatusLabel: Object.keys(apiResult).length > 0 ? Object.values(apiResult)[0]?.statusLabelName : "",
          messageToShow: Object.keys(apiResult).length > 0 ? Object.values(apiResult)[0]?.messageToShow : "",
          queryType: Object.keys(apiResult).length > 0 ? Object.values(apiResult)[0].queryType : "",
          selectedCommunicationTeam: Object.keys(apiResult).length > 0
            ? (() => {
                const currentStatus = Object.values(apiResult)[0].currentStatus;
                const isStatusAllowed = allowedStatuses.includes(currentStatus);
                const canShowForEveryone = isStatusAllowed && this.props.userQueryType === 'enhancements' && this.state.isEstimationAvailble;
                const canShowForAdmin = isStatusAllowed && this.state.isEstimationAvailble && isCCAdmin;
                return (canShowForEveryone || canShowForAdmin) ? "Quotation Approval" : "Client Communication";
              })()
            : "Client Communication"

        });


      } else {
        toast.error(jsonResponse.APIResult.message)
        console.error("Something went wrong while fetching the data.");
        this.setState({
          currentClientResponse: {}, clientResponseFetching: false,
          currentReleaseDetails: {},
          currentQueryStatus: "",
          currentQueryStatusLabel: "",
          messageToShow: ""
        });

      }
    }
  }

  // <button className="tab active">Client Response</button>
  // <button className="tab">Executive Response</button>
  serviceExecutiveResponse = [
    {
      team: 'Client Response',
    },
    {
      team: 'Executive Response',
    },


  ]
  communicationTeam = [
    {
      id: '1',
      name: 'Client Communication',
      component: <ClientCommunication/>,

    },
    {
      id: '2',
      name: 'Quotation Approval',
      component: <QuotationApproval />,
    },
    // {
    //   id: '3',
    //   name: 'Estimation',
    //   component: <Estimation />,
    // }
  ]
  // Handle response selection
  handleResponse = (selectedResponse) => {
    this.setState({ selectedResponse }); // Update state with the selected response
  };
  // Handle communication team selection
  handleCommunicationTeam = (selectedCommunicationTeam) => {
    this.setState({ selectedCommunicationTeam });
  };
  // Handle form submission
  // Render the modal
  // Fetch Communication Modal
  returnCommunicationModal = () => {
  }
  handleReopenSR = () => {
    this.setState({ reOpenSrModal: true })
  };

  handleCloseServiceRequestModal = () => {
    this.setState({
      reOpenSrModal: false
    });
    this.props.onCloseModal();
  }
  render() {
    const { openServiceRequestModal, onCloseModal } = this.props;
    return (

      <div className={openServiceRequestModal ? "modal fade show" : "modal fade"} id="modalContainer" >
        <div className="modal-dialog serviceRequestFormContainer">
          <div className="modal-content custom-service-modal-content">
            <div
              style={{ display: 'flex', flexDirection: 'row', padding: '15px 30px 15px 36px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
            >

              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                <img
                  src={backToRequests}
                  alt="backToRequests"
                  height={"30px"}
                  width={"30px"}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onCloseModal()}
                />


                <p className='vm_custom_subtitle2' style={{ textTransform: "capitalize", fontSize: 20, color: '#000000' }}>Service Request</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                {
                  this.state.currentQueryStatus == 'Close' && (
                    <div
                      style={{ display: "flex", flexDirection: "row", gap: "9px" }}
                    >

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "9px",
                        }}
                      >
                        {(this.state.currentQueryStatus == 'Close') &&
                          <button
                            className="vm_custom_body6"
                            onClick={() => this.handleReopenSR()}
                            style={{ lineHeight: "18px", backgroundColor: '#FFF', color: '#0465ac', padding: '4px 8px', border: '1px solid #0465ac', borderRadius: '4px' }}
                          >
                            Reopen SR
                          </button>}



                      </div>
                    </div>
                  )}
                <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#808080" onClick={() => onCloseModal()} />
              </div>
            </div>

            <div className="service-request-modal-body">
              {/* Top Header */}
              <div
                style={{
                  height: "100px",
                  borderTopLeftRadius: "7px",
                  borderTopRightRadius: "7px",
                  border: "1px solid #E6EBEF",
                  background: "#F9FAFB",
                  width: "100%",
                  gap: "9px",
                  padding: "20px 20px 0px 36px",
                }}
              >
                <div
                  className='header-container'
                  style={{
                    // display: "flex",
                    // flexDirection: "row",
                    // justifyContent: "space-between",
                    paddingRight: "10px",
                  }}
                >
                  <div
                    style={{ display: "flex", flexDirection: "row", gap: "9px" }}
                  >
                    <img
                      src={bookIcon}
                      alt="Icondetas"
                      height={"40px"}
                      width={"40px"}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "9px",
                        width: "auto",
                      }}
                    >
                      <p
                        className="vm_custom_body6"
                        style={{ lineHeight: "18px", width: "auto", color: "#263E59" }}
                      >

                        User Details : {Object.keys(this.state.currentClientResponse).length > 0 && Object.values(this.state.currentClientResponse)[0].addedByName} | {Object.keys(this.state.currentClientResponse).length > 0 && Object.values(this.state.currentClientResponse)[0].addedByErPId}
                      </p>
                      <p
                        className="vm_custom_body10"
                        style={{ lineHeight: "18px", color: "#263E59" }}
                      >
                        <span className='vm_custom_overline1'> Service Request ID : </span>
                        <span className='vm_custom_overline1' style={{ fontWeight: 'bold' }}>{this.props.srId}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div style={{ alignItems: 'left', display: 'flex', flexDirection: 'column', gap: '0px' }}>


                    <div
                      style={{ display: "flex", flexDirection: "row", gap: "9px", width: '95%' }}
                    >
                      <img
                        src={AssignedDateImage}
                        alt="Icondetas"
                        height={"40px"}
                        width={"40px"}
                      />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          textAlign: 'left',
                          width: '100%',
                          height: '100%',
                        }}
                        title={this.state.messageToShow}
                      >
                        <span
                          className='vm_custom_body6'
                          style={{
                            color: "#263E59",
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            whiteSpace: 'normal',
                          }}
                        >
                          {this.state.messageToShow}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{ display: "flex", flexDirection: "row", gap: "9px", marginLeft: 'auto' }}
                  >
                    <div
                      style={{ display: "flex", flexDirection: "row", gap: "9px" }}
                    >
                      <img
                        src={AssignedDateImage}
                        alt="Icondetas"
                        height={"40px"}
                        width={"40px"}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "9px",
                        }}
                      >
                        <p
                          className="vm_custom_body6"
                          style={{ lineHeight: "18px" }}
                        >
                          Assigned On
                        </p>
                        <p
                          className="vm_custom_body6"
                          style={{ lineHeight: "18px", color: "#263E59" }}
                        >
                          {Object.keys(this.state.currentClientResponse).length > 0 && Object.values(this.state.currentClientResponse)[0].readableCreatedOn}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", flexDirection: "row", gap: "9px" }}
                    >
                      <img
                        src={StatusImage}
                        alt="Status"
                        style={{ height: '40px', width: '40px' }}

                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "9px",
                        }}
                      >
                        <p
                          className="vm_custom_body6"
                          style={{ lineHeight: "18px" }}
                        >
                          Status
                        </p>
                        <p
                          className="vm_custom_body6"
                          style={{ lineHeight: "18px", color: this.state.currentQueryStatus === 'Close' ? 'green' : "orange" }}
                        >
                          {this.state.currentQueryStatusLabel}

                        </p>
                      </div>
                    </div>

                  </div>
                </div>
                {/* <p className="vm_custom_body5">Task Details : {'Please Complete this Task'}</p> */}
              </div>

              <div className='layout-container'>
                {/* Column 1: Service Request Details */}
                <div className="service-request-details">
                  <p className='vm_custom_subtitle5' style={{ color: '#000000' }}>Service Request Details</p>
                  <div className="tabs" style={{ marginTop: '15px', width: '100%' }}>

                    {
                      this.serviceExecutiveResponse.map((response, index) => {
                        return (
                          <p key={index} className={`vm_custom_subtitle5 tab ${response.team === this.state.selectedResponse ? 'active' : ''}`} onClick={() => this.handleResponse(response.team)}>{response.team}</p>
                        )
                      })
                    }
                  </div>
                  <div>
                    {/* Render Component base on Executive Response and Client Response */}
                    <div>
                      {
                        this.state.selectedResponse === 'Executive Response' && <ExecutiveResponse
                          currentClientResponse={this.state.currentClientResponse}
                          // currentRequest={this.props.currentRequest}
                          currentQueryRequestId={this.state.currentQueryRequestId} />

                      }
                      {
                        this.state.selectedResponse === 'Client Response' && <ClientResponse
                          currentClientResponse={this.state.currentClientResponse}
                          // currentRequest={this.props.currentRequest}
                          currentQueryRequestId={this.state.currentQueryRequestId} />

                      }

                    </div>
                  </div>
                </div>

                {/* Column 2: Communication Section */}
                <div className="communication-section">
                  <div className="tabs">
                    {
                      this.communicationTeam
                        .filter(communication => {
                          if (communication.name === 'Quotation Approval') {
                            const allowedStatuses = [
                              'Admin Document Approval',
                              'Quotation Approval by Client',
                              'Release Planning',
                              'UX Completed',
                              'QA Approved Available on Production',
                              'Closer confirmation',
                              'Close'
                            ];

                            const isStatusAllowed = allowedStatuses.includes(this.state.currentQueryStatus);
                            const isEnhancement = this.props.userQueryType === 'enhancements';
                            const isCCAdmin = this.props.isCCAdminMember === "true";
                            const estimationAvailability = this.state.isEstimationAvailble;

                            // Condition A: enhancement + estimation + allowed status -> show for everyone
                            const canShowForEveryone = isStatusAllowed && isEnhancement && estimationAvailability;
                            // Condition B: if condition A not met, only CC admin with allowed status + estimation can see
                            const canShowForAdmin = isStatusAllowed && estimationAvailability && isCCAdmin;

                            return canShowForEveryone || canShowForAdmin;
                          }

                          return true;
                        })
                        .map(communication => {
                          return (
                            <p
                              key={communication.id}
                              className={`vm_custom_subtitle5 tab ${communication.name === this.state.selectedCommunicationTeam ? 'active' : ''}`}
                              onClick={() => this.handleCommunicationTeam(communication.name)}
                            >
                              {communication.name}
                            </p>
                          );
                        })
                    }

                  </div>
                  {/* Render Component base on   */}
                  <>
                    {
                      Object.values(this.state.currentClientResponse)[0]?.queryType === 'enhancements' &&
                      <>
                        {this.state.selectedCommunicationTeam === 'Client Communication' && <EnhancementClientCommunication
                          // currentRequest={this.props.currentRequest}
                          clientResponseDetails={this.state.currentClientResponse}
                          currentQueryRequestId={this.state.currentQueryRequestId}
                          onCloseModal={this.props.onCloseModal}
                          isCCAdminMember={this.props.isCCAdminMember}
                          adminUpdateStatus={this.state.currentQueryStatus}

                           isEstimationAvailble={this.state.isEstimationAvailble} 
                        />
                        }
                        {
                          this.state.selectedCommunicationTeam === 'Quotation Approval' && <QuotationApproval
                            currentRequest={this.props.currentRequest}
                            isCCAdminMember={this.props.isCCAdminMember}
                            currentClientResponse={this.state.currentClientResponse}
                            currentQueryRequestId={this.state.currentQueryRequestId}
                            adminUpdateStatus={this.state.currentQueryStatus}
                            onCloseModal={this.props.onCloseModal}


                          />
                        }


                      </>

                    }
                    {
                      (Object.values(this.state.currentClientResponse)[0]?.queryType === 'designs' || Object.values(this.state.currentClientResponse)[0]?.queryType === 'errors') &&
                      this.state.selectedCommunicationTeam === 'Client Communication' && <ClientCommunication
                        // currentRequest={this.props.currentRequest}
                        clientResponseDetails={this.state.currentClientResponse}
                        currentQueryRequestId={this.state.currentQueryRequestId}
                        onCloseModal={this.props.onCloseModal}
                      />
                    }

                  </>


                </div>

                {/* Column 3: Service Request Status */}
                <div className="service-request-status">
                  <p className='vm_custom_subtitle5' style={{ color: '#000000' }}>Service Request Status</p>

                  <>
                    {
                      Object.values(this.state.currentClientResponse)[0]?.queryType === 'enhancements' ?
                        <EnhancementVerticalStepper currentClientResponse={this.state.currentClientResponse}
                          currentQueryRequestId={this.state.currentQueryRequestId}
                          isCCAdminMember={this.props.isCCAdminMember}
                          adminUpdateStatus={this.state.currentQueryStatus}
                        /> :

                        <VerticalStepper currentClientResponse={this.state.currentClientResponse}
                          currentQueryRequestId={this.state.currentQueryRequestId}
                          isCCAdminMember={this.props.isCCAdminMember}
                          adminUpdateStatus={this.state.currentQueryStatus}
                        />
                    }
                  </>

                </div>
              </div>
            </div>
          </div>

        </div>
        {

          this.state.reOpenSrModal && <AddRequestModal
            selectedModuleName={Object.values(this.state.currentClientResponse)[0]?.moduleName}
            selectedModuleId={Object.values(this.state.currentClientResponse)[0]?.moduleId}

            currentClientResponse={this.state.currentClientResponse}
            selectedQueryType={this.state.queryType}
            openExecutiveResponse={this.state.reOpenSrModal}
            isOnboarded={this.props.isOnboarded}
            onCloseModal={this.handleCloseServiceRequestModal} />
        }
      </div>
    )
  }
}

export default ViewRequestModal
